var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55664 8.08333H20.5566M19.5566 8.08333L18.6896 21.2372C18.6537 21.7838 18.4279 22.2954 18.0578 22.6689C17.6876 23.0424 17.2005 23.25 16.6946 23.25H8.41864C7.91278 23.25 7.42571 23.0424 7.05553 22.6689C6.68534 22.2954 6.45956 21.7838 6.42364 21.2372L5.55664 8.08333H19.5566ZM10.5566 12.4167V18.9167V12.4167ZM14.5566 12.4167V18.9167V12.4167ZM15.5566 8.08333V4.83333C15.5566 4.54602 15.4513 4.27047 15.2637 4.0673C15.0762 3.86414 14.8219 3.75 14.5566 3.75H10.5566C10.2914 3.75 10.0371 3.86414 9.84953 4.0673C9.662 4.27047 9.55664 4.54602 9.55664 4.83333V8.08333H15.5566Z",
    stroke: "#FF4C55",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.380bb7d21c2bd0f41f4c40cc25f7e716.svg";
export { ForwardRef as ReactComponent };